export default __webpack_public_path__ + "static/media/47.36460ac0.jpg";